'use client'

import React from 'react'
import Link from 'next/link'
import { RebrandVideoRecorderIcon } from '@/components/Icons/Rebrand/VideoRecorderIcon'
import classes from './SeeHowItWorksButton.module.css'

const CTA_LABEL = 'See how it works'

export interface SeeHowItWorksButtonProps {
    href: string
    /** When true, render as a button that opens the video modal. */
    opensVideo: boolean
    onVideoClick?: () => void
}

export default function SeeHowItWorksButton({ href, opensVideo, onVideoClick }: SeeHowItWorksButtonProps) {
    const content = (
        <>
            <RebrandVideoRecorderIcon className={classes.icon} aria-hidden />
            <span className={classes.label}>{CTA_LABEL}</span>
        </>
    )

    if (opensVideo) {
        return (
            <button type="button" className={classes.button} onClick={onVideoClick} aria-label={CTA_LABEL}>
                {content}
            </button>
        )
    }

    return (
        <Link href={href} prefetch={false} className={classes.button} aria-label={CTA_LABEL}>
            {content}
        </Link>
    )
}
